<template>
  <div>
    <md-content class="center-logo">
      <img src="/img/logo.svg" height="200" alt="Museu d'Història de Manacor" class="logo">
    </md-content>
  </div>
</template>

<script>
    export default {
        name: "vue-splash"
    }
</script>

<style scoped>
  .logo {
    height: 170px;
  }
  .center-logo {
    height: 100vh;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
</style>
